import { useState, useEffect } from 'react'
import Icons from './Icons'

const navLinks = [
  { label: '使用指南', href: '/guide/' },
  { label: '安全指南', href: '/safety/' },
  { label: '交易对比', href: '/compare/' },
  { label: '交易术语', href: '/glossary/' },
  { label: '常见问题', href: '/faq/' },
  { label: '新手入门', href: '/start/' },
]

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[rgba(10,10,15,0.95)] backdrop-blur-xl border-b border-[rgba(255,0,255,0.1)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a
            href="/"
            className="flex items-center gap-2 transition-transform hover:-translate-y-0.5"
          >
            <img
              src="/navbar-logo.png"
              alt="okb官网"
              className="h-8 md:h-10 w-auto"
              onError={(e) => {
                const target = e.target as HTMLImageElement
                target.style.display = 'none'
                target.nextElementSibling?.classList.remove('hidden')
              }}
            />
            <span className="hidden text-2xl font-bold gradient-text">okb</span>
          </a>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-[#8080a0] hover:text-[#e0e0ff] transition-all hover:-translate-y-0.5 text-sm font-medium"
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-4">
            <a
              href="https://www.jsqkmfytwpn.com/join/1p9999"
              target="_blank"
              rel="noopener"
              className="text-[#e0e0ff] hover:text-[#ff00ff] transition-colors text-sm font-medium"
            >
              登录
            </a>
            <a
              href="https://www.jsqkmfytwpn.com/join/1p9999"
              target="_blank"
              rel="noopener"
              className="btn-primary text-sm"
            >
              注册
            </a>
          </div>

          <button
            className="md:hidden p-2 text-[#e0e0ff] cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <Icons.Close /> : <Icons.Menu />}
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-[rgba(10,10,15,0.98)] border-t border-[rgba(255,0,255,0.1)]">
          <div className="px-6 py-4 space-y-4">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="block text-[#8080a0] hover:text-[#e0e0ff] transition-colors py-2"
              >
                {link.label}
              </a>
            ))}
            <div className="pt-4 border-t border-[rgba(255,0,255,0.1)] space-y-3">
              <a
                href="https://www.jsqkmfytwpn.com/join/1p9999"
                target="_blank"
                rel="noopener"
                className="block text-center text-[#e0e0ff] py-2"
              >
                登录
              </a>
              <a
                href="https://www.jsqkmfytwpn.com/join/1p9999"
                target="_blank"
                rel="noopener"
                className="block btn-primary text-center"
              >
                注册
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  )
}
